exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-4ec034bc]{font-size:65px}h1[data-v-4ec034bc],h2[data-v-4ec034bc]{font-family:Roboto Slab,sans-serif;font-weight:700}h2[data-v-4ec034bc]{font-size:40px}#header h1[data-v-4ec034bc]{background-image:url(\"/src/assets/IMG_9923.jpg\");background-size:cover;min-height:200px;background-repeat:no-repeat;background-attachment:fixed;color:#fff;font-family:Roboto Slab,sans-serif;font-size:65px;font-weight:700;padding-top:3%}#content[data-v-4ec034bc],.container[data-v-4ec034bc]{margin-right:auto;margin-left:auto;text-align:left;max-width:70%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ec034bc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Blog-Entries/Queenstown.vue
// module id = 119
// module chunks = 0